<template>
  <div class="carAuth-container">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
          添加授权
        </el-button>
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-delete" @click="handleDel">
          批量删除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-tickets" @click="handleView(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-edit-outline" @click="handleUpdate(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-delete" @click="handleRowDel(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="carAuthTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="addModalClose"
      width="60%">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="70px">
        <el-form-item label="有效期" prop="validTime">
          <el-date-picker v-model="addForm.validTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="select-box">
        <div class="select-box-item">
          <carSelect ref="carSelectRef" :key="randomData()" @carData="carData" :updateCarsData="updateCarsData">
          </carSelect>
        </div>
        <div class="select-box-item">
          <deviceSelect ref="deviceSelectRef" :key="randomData()" @deviceData="deviceData"
            :updateDevicesData="updateDevicesData"></deviceSelect>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="detailTitle" :visible.sync="detailVisible" append-to-body :close-on-click-modal="detailmodalClose"
      width="42%">
      <el-descriptions border :column="2">
        <el-descriptions-item label="车牌号">{{ detailForm.plateCode }}</el-descriptions-item>
        <el-descriptions-item label="车主姓名">{{ detailForm.ownerName }}</el-descriptions-item>
        <el-descriptions-item label="车辆类型">{{ vehicleTypeFormatter(detailForm.vehicleType) }}</el-descriptions-item>
        <el-descriptions-item label="车辆颜色">{{ vehicleColorFormatter(detailForm.vehicleColor) }}</el-descriptions-item>
        <el-descriptions-item label="车牌颜色">{{ plateColorFormatter(detailForm.plateColor) }}</el-descriptions-item>
        <el-descriptions-item label="授权时间">{{ detailForm.createTime }}</el-descriptions-item>
        <el-descriptions-item label="生效时间">{{ detailForm.effectiveTime }}</el-descriptions-item>
        <el-descriptions-item label="失效时间">{{ detailForm.expirationTime }}</el-descriptions-item>
      </el-descriptions>
      <div style="margin: 15px 2px;">
        <span>授权设备：</span>
      </div>
      <el-table :data="detailForm.tableData" style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="deviceId" label="设备编号"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@src/common/utils";
import { Dic } from "$utils";
import { formatTimeToStr } from "../filter/dateUtils";
import { api } from "../api";
import tableOption from '../config/tableOption';
import carSelect from "../components/carSelect.vue";
import deviceSelect from "../components/deviceSelect.vue";
export default {
  components: {
    carSelect,
    deviceSelect
  },
  data() {
    return {
      tableData: [],
      option: tableOption(),
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchForm: {},
      carAuthTitle: '车辆通行授权',
      addModalClose: false,
      addVisible: false,
      addRules: {
        validTime: [{ required: true, message: '请选择有效期', trigger: 'blur' }]
      },
      addForm: {
        validTime: '',
        carId: ''
      },
      selectCarData: [],
      selectDeviceData: [],
      checkedData: [],
      detailTitle: '详情',
      detailVisible: false,
      detailmodalClose: false,
      detailForm: {
        plateCode: '',
        ownerName: '',
        vehicleType: '',
        vehicleColor: '',
        plateColor: '',
        effectiveTime: '',
        expirationTime: '',
        createTime: '',
        tableData: []
      },
      updateCarsData: [],
      updateDevicesData: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    randomData() {
      return Math.random(Math.random() * 100)
    },
    handleSearchChange(param) {
      console.info('this.searchForm', param)
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    handleSelectionChange(items) {
      // this.checkedData = items.map((item) => {
      //   return item.id;
      // });
      this.checkedData = items
    },
    getList() {
      let params = {
        auth: '1',
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        plateCode: this.searchForm.plateCode,
        ownerName: this.searchForm.ownerName,
        vehicleType: this.searchForm.vehicleType,
      };
      if (this.searchForm.effectiveTime && this.searchForm.effectiveTime.length > 0) {
        params.authStartTime = formatTimeToStr(this.searchForm.effectiveTime[0]);
        params.authEndTime = formatTimeToStr(this.searchForm.effectiveTime[1]);
      }
      this.$fetch(api.queryVehicleAuthority, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.carAuthTitle = "新增授权信息"
      this.addForm.validTime = ""
      this.addForm.carId = ""
      this.updateCarsData = []
      this.updateDevicesData = []
      if (this.selectCarData.length > 0) {
        this.$refs.carSelectRef.clearSelect()
      }
      if (this.selectDeviceData.length > 0) {
        this.$refs.deviceSelectRef.clearSelect()
      }
      this.addVisible = true
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.selectCarData.length == 0) {
            this.$message.warning("请选择授权车牌号")
            return
          }
          if (this.selectDeviceData.length == 0) {
            this.$message.warning("请选择车辆道闸")
            return
          }
          let carArr = []
          let deviceArr = []
          for (let i = 0; i < this.selectCarData.length; i++) {
            carArr.push({
              "plateCode": this.selectCarData[i].plateCode,
              "carId": this.selectCarData[i].carId
            })
          }
          for (let j = 0; j < this.selectDeviceData.length; j++) {
            deviceArr.push({
              "deviceId": this.selectDeviceData[j].deviceId,
              "thirdDeviceId": this.selectDeviceData[j].thirdDeviceId,
            })
          }
          if (this.addForm.carId == "") {
            let params = {
              devices: deviceArr,
              cars: carArr,
              effectiveTime: this.addForm.validTime[0],
              expirationTime: this.addForm.validTime[1]
            }
            this.$fetch(api.addCarAuth, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              carId: this.addForm.carId,
              devices: deviceArr,
              cars: carArr,
              effectiveTime: this.addForm.validTime[0],
              expirationTime: this.addForm.validTime[1]
            }
            this.$fetch(api.updateCarAuth, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    addCancel() {
      this.addVisible = false
    },
    handleDel() {
      if (this.checkedData.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的授权数据",
        });
        return;
      }
      let carArr = []
      for (let i = 0; i < this.checkedData.length; i++) {
        carArr.push({
          "plateCode": this.checkedData[i].plateCode,
          "carId": this.checkedData[i].carId
        })
      }
      this.$confirm("您确定要删除选中的授权数据吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.delCarAuth, { "cars": carArr }).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    carData(item) {
      this.selectCarData = item
    },
    deviceData(item) {
      this.selectDeviceData = item
    },
    vehicleTypeFormatter: function (value) {
      return value ? Dic.findByValue("SENU038", value) : "";
    },
    vehicleColorFormatter: function (value) {
      return value ? Dic.findByValue("SENU039", value) : "";
    },
    plateColorFormatter: function (value) {
      return value ? Dic.findByValue("SENU040", value) : "";
    },
    handleView(row) {
      let params = {
        plateCode: row.plateCode,
      };
      this.$fetch(api.queryCarAuthDetail, params).then((response) => {
        if (response.success) {
          this.detailForm.plateCode = response.returnObj.vehiclebeInfo.plateCode
          this.detailForm.ownerName = response.returnObj.vehiclebeInfo.ownerName
          this.detailForm.vehicleType = response.returnObj.vehiclebeInfo.vehicleType
          this.detailForm.vehicleColor = response.returnObj.vehiclebeInfo.vehicleColor
          this.detailForm.plateColor = response.returnObj.vehiclebeInfo.plateColor
          this.detailForm.effectiveTime = response.returnObj.vehiclebeInfo.effectiveTime
          this.detailForm.expirationTime = response.returnObj.vehiclebeInfo.expirationTime
          this.detailForm.createTime = response.returnObj.vehiclebeInfo.createTime
          this.detailForm.tableData = response.returnObj.devices
          this.detailVisible = true
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    detailCancel() {
      this.detailVisible = false
    },
    handleUpdate(row) {
      this.carAuthTitle = "修改授权信息"
      this.addForm.carId = row.carId
      let params = {
        plateCode: row.plateCode,
      };
      this.$fetch(api.queryCarAuthDetail, params).then((response) => {
        if (response.success) {
          let responseData = response.returnObj
          this.addForm.validTime = [responseData.vehiclebeInfo.effectiveTime, responseData.vehiclebeInfo.expirationTime]
          this.updateCarsData = [responseData.vehiclebeInfo]
          this.updateDevicesData = responseData.devices
          this.addVisible = true
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleRowDel(row) {
      let params = [{
        "plateCode": row.plateCode,
        "carId": row.carId
      }]
      this.$confirm("您确定要删除此条授权数据吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.delCarAuth, { "cars": params }).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.carAuth-container {
  width: 100%;
  height: 100%;
}

.select-box {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;

  .select-box-item {
    flex: 1;
    width: 0;
    height: 500px;
  }
}
</style>
